import api, { checkTokenErrorResponse } from '..';

const productTypes = [
    [0, 'Venda'],
    [1, 'Patrimonial'],
    [2, 'Institucional'],
    [3, 'Nutricional'],
    [4, 'Uso Consumo']
]

const productCategories = [
    [0, 'Uniforme'],
    [1, 'Alimentos'],
    [2, 'Bens Materiais'],
    [10, 'Outros']
]

const stockMovementTypes = [
    [0, 'Entrada'],
    [1, 'Saída'],
    [-1, "Criação"],
]

const tipos_unidade = [
    ['un', 'Unidade'],
    ['kg', 'Quilograma'],
    ['l', 'Litro'],
]

const tipos_icms_origem = [
    [0, "Nacional"],
    [1, "Estrangeira (importação direta)"],
    [2, "Estrangeira (adquirida no mercado interno)"],
    [3, "Nacional com mais de 40% de conteúdo estrangeiro"],
    [4, "Nacional produzida através de processos produtivos básicos"],
    [5, "Nacional com menos de 40% de conteúdo estrangeiro"],
    [6, "Estrangeira (importação direta) sem produto nacional similar"],
]

const tipos_icms_situacao_tributaria = [
    ["101", "Tributada pelo Simples Nacional com permissão de crédito"],
    ["102", "Tributada pelo Simples Nacional sem permissão de crédito"],
]

const tipos_pis_cofins_situacao_tributaria = [
    ["49", "Outras operações de saída"],
    ["99", "Outras operações"],
]

const tipos_cfop = [
    //coloca '02'
    [1, 'VENDA DE MERCADORIA ADQUIRIDA OU RECEBIDA DE TERCEIROS'],
    //coloca 5405 ou 6403
    [2,'VENDA DE MERCADORIA, ADQUIRIDA OU RECEBIDA DE TERCEIROS, SUJEITA A ST, NA CONDIÇÃO DE CONTRIBUINTE-SUBSTITUÍDO']
];

export async function getProducts() {
    return api.get("produtos/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function getInfoNewProduct() {
    return api.get("produtos/informacoes_novo_produto/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postProduct(
    nome,
    centro_de_custo,
    plano_de_contas,
    tipo,
    categoria,
    quantidade,
    quantidade_critica,
    valor_unitario_comercial,
    unidade_comercial,
    codigo_ncm,
    icms_origem,
    icms_situacao_tributaria,
    pis_situacao_tributaria,
    cofins_situacao_tributaria,
    CFOP,
    CEST,
    cEAN,
    cEANTrib) {
    const formdata = new FormData();

    formdata.append("nome", nome);
    formdata.append("centro_de_custo", centro_de_custo);
    formdata.append("plano_de_contas", plano_de_contas);
    formdata.append("tipo", tipo);
    formdata.append("categoria", categoria);
    formdata.append("quantidade", quantidade);
    formdata.append("quantidade_critica", quantidade_critica);
    formdata.append("valor_unitario_comercial", valor_unitario_comercial);
    formdata.append("unidade_comercial", unidade_comercial);
    formdata.append("codigo_ncm", codigo_ncm);
    formdata.append("icms_origem", icms_origem);
    formdata.append("icms_situacao_tributaria", icms_situacao_tributaria);
    formdata.append("pis_situacao_tributaria", pis_situacao_tributaria);
    formdata.append("cofins_situacao_tributaria", cofins_situacao_tributaria);
    formdata.append("CFOP", CFOP);
    formdata.append("CEST", CEST);
    formdata.append("cEAN", cEAN);
    formdata.append("cEANTrib", cEANTrib);

    return api.post(`produtos/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getProduct(id) {
    return api.get(`produtos/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteProduct(id) {
    return api.delete(`produtos/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function patchProduct(
    id,
    nome,
    centro_de_custo,
    plano_de_contas,
    tipo,
    categoria,
    quantidade,
    quantidade_critica,
    valor_unitario_comercial,
    unidade_comercial,
    codigo_ncm,
    icms_origem,
    icms_situacao_tributaria,
    pis_situacao_tributaria,
    cofins_situacao_tributaria,
    CFOP,
    CEST,
    cEAN,
    cEANTrib) {
    const formdata = new FormData();

    formdata.append("nome", nome);
    formdata.append("centro_de_custo", centro_de_custo);
    formdata.append("plano_de_contas", plano_de_contas);
    formdata.append("tipo", tipo);
    formdata.append("categoria", categoria);
    formdata.append("quantidade", quantidade);
    formdata.append("quantidade_critica", quantidade_critica);
    formdata.append("valor_unitario_comercial", valor_unitario_comercial);
    formdata.append("unidade_comercial", unidade_comercial);
    formdata.append("codigo_ncm", codigo_ncm);
    formdata.append("icms_origem", icms_origem);
    formdata.append("icms_situacao_tributaria", icms_situacao_tributaria);
    formdata.append("pis_situacao_tributaria", pis_situacao_tributaria);
    formdata.append("cofins_situacao_tributaria", cofins_situacao_tributaria);
    formdata.append("CFOP", CFOP);
    formdata.append("CEST", CEST);
    formdata.append("cEAN", cEAN);
    formdata.append("cEANTrib", cEANTrib);
    
    return api.patch(`produtos/${id}/`,formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postStockMovement(id, tipo, quantidade, descricao) {
    const formdata = new FormData();

    formdata.append("quantidade", quantidade);
    formdata.append("tipo", tipo);
    formdata.append("descricao", descricao);

    return api.post(`movimentacoes_estoque/${id}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function getStockMovements(id) {
    return api.get(`movimentacoes_estoque/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

const productServices = {
    getProduct,
    getInfoNewProduct,
    getProducts,
    postProduct,
    deleteProduct,
    patchProduct,
    postStockMovement,
    getStockMovements,
    productTypes,
    productCategories,
    stockMovementTypes,
    tipos_icms_origem,
    tipos_icms_situacao_tributaria,
    tipos_pis_cofins_situacao_tributaria,
    tipos_unidade,
    tipos_cfop
}
export default productServices;